/// <amd-module name="typeahead/features/NLPSuggestion" />

"use strict";

import {IInputElementConfig} from "typeahead/core/ExpediaSuggestServiceRequestGenerator";
import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

// Enable this experiment for only english locales
const configuration: IStripingConfiguration[] = [
    {
        deviceTypes: ["Desktop"],
        experiment: {
            id: 25163,
            name: "ess_nlp_typeahead_suggestion",
            value: 1,
        },
        lobs: ["HOTELS"],
    },
];

const featureFlag = "nlpta";

export class NLPSuggestion implements IRequestUrlParamModifier, ISuggestionsModifier, IExperimentalFeature {

    private readonly applicableLocales: string[] =
        ["en_AU", "en_CA", "en_GB", "en_HK", "en_IE", "en_MY", "en_NZ", "en_PH", "en_SG", "en_US"];

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: IInputElementConfig):
    ISuggestServiceQueryParams {

        // Do exposure logging only for en locales
        if (this.checkLogExposureConditions(context, options)) {
            // send feature flag only when in variant 1
            addFeatureFlag(featureFlag, configuration, params, context);
        }
        return params;
    }

    // This function will modify suggestions into display groups of nlp suggestions and google suggestions
    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any): object[] {
        if (this.checkLogExposureConditions(context, options)) {
            if (options.renderTrigger === "type") {
                suggestions.forEach((suggestion: IEssSuggestionResult, index: number): void => {
                    if (suggestion.category === "GOOGLEMAPS") {
                        suggestion.displayGroup = {
                            groupName: "GoogleSuggestion",
                            label: "",
                        };
                    }
                });
            }
        }

        return suggestions;
    }

    private checkLogExposureConditions(context: IContext, options: any): boolean {
        return this.applicableLocales.indexOf(context.locale) > -1
            && !TypeaheadUtils.isWithinMobileBreakpoint() && ExecutionHelper.shouldExecute(context, configuration);
    }
}
